module.exports = __webpack_public_path__ + "img/grin_logo.75301b6e.png";